module.exports = __webpack_public_path__ + "img/core-enterprises.21b4fc55.svg";